module.exports = __webpack_public_path__ + "img/bg_airport.984f62cf.jpg";